import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import DropOffOrderDriver from './DropOffOrderDriver';

import User from '../../../models/User';
import ApiResponse from '../../../models/ApiResponse';
import PickupOrder from '../../../models/PickupOrder';
import ResponseError from '../../../models/ResponseError';

import { Moment as MomentType } from 'moment';
import Moment from 'moment';
import { PO_SCHEMA } from '../../../utils/pickupOrder';
import { handlePrintPickupOrder } from '../../../utils/printing';

interface DropOffOrderDriverContainerProps {
  user: User;
  history: any;
  match: { params: { dooNumber: string, secretKey: string } };
  receiveError: (error: ResponseError) => void;
  receiveSuccess: (message: string) => void;
};

interface DropOffOrderDriverContainerState {
  doo: PickupOrder;
  dooNumber: string;
  secretKey: string;
  dropOffTimeError: boolean;
};

class DropOffOrderDriverContainer extends Component<DropOffOrderDriverContainerProps, DropOffOrderDriverContainerState> {

  state = {
    doo: PO_SCHEMA,
    dooNumber: '',
    secretKey: '',
    dropOffTimeError: false
  }

  componentDidMount() {

    this.load();
  }

  load = (): void => {
    const dooNumber: string = this.props.match.params.dooNumber;
    const secretKey: string = this.props.match.params.secretKey;

    pickupOrderRemote.getPickupOrder(dooNumber, secretKey).then((resp: ApiResponse<PickupOrder>) => {

      const doo: PickupOrder | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (doo) {
        
        const dropOffOrder: PickupOrder = { ...doo };
        dropOffOrder.pickup_time = doo.latest_eta;

        this.setState({ doo: dropOffOrder, dooNumber, secretKey });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  };


  doCheckIn = (): void => {

    const dooNumber: string = this.state.dooNumber;
    const secretKey: string = this.state.secretKey;

    if (dooNumber && secretKey) {

    navigator.geolocation.getCurrentPosition(
      position => {
        const { latitude, longitude } = position.coords;
        this.sendCheckInRequest(dooNumber, secretKey, {lat: latitude, lng: longitude});
      },
      () => {
        this.props.receiveError({errorCode: '', longDescription: 'You need to enable the location of your device in order to use that feature.'});
      }
    );
    }
  }

  sendCheckInRequest = (doNumber: string, secretKey: string, location?: { lat: number, lng: number}) => {
    pickupOrderRemote.driverCheckIn(doNumber, secretKey, location).then((resp: ApiResponse<boolean>) => {

      const success: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (success) {
        this.props.receiveSuccess('Checked In.');
        this.setState({doo: Object.assign(this.state.doo, {driver_checkin_time: "0000"})});
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  saveSecurityDetails = (locked: boolean, sealed: boolean, sealNumber: string): void => {

    const dooNumber: string = this.state.dooNumber;
    const secretKey: string = this.state.secretKey;

    pickupOrderRemote.setSecurityDetails(dooNumber, { sealed: sealed, seal_number: sealNumber, locked: locked }, secretKey)
    .then((resp: ApiResponse<{ sealed: boolean, seal_number: string, locked: boolean }>) => {
       const error: ResponseError | undefined = resp.error;

       if (error) {
         this.props.receiveError(error);
       };
    });
  }

  selectETA = (): void => {

    const currState: DropOffOrderDriverContainerState = { ...this.state };
    const dooNumber: string = currState.dooNumber;
    const secretKey: string = currState.secretKey;
    
    if (dooNumber && secretKey) {
      this.props.history.push(`/drv-map/do/${dooNumber}/${secretKey}`);
    }
  }

  handleDropOffTimeChange = (dateTime: MomentType): void => {

    const doo: PickupOrder = { ...this.state.doo };

    if (doo.cutoff_time) {

      const cutOffTime: Date = Moment(doo.cutoff_time, "HHmm").toDate();
      const dropOffTime: Date = Moment(dateTime, "HHmm").toDate();
      const dropOffTimeStr: string = Moment(dateTime).format('HHmm');
      let dropOffTimeError: boolean = this.state.dropOffTimeError;
  
      if (doo.pickup_date < doo.cutoff_date || dropOffTime <= cutOffTime) {
  
        dropOffTimeError = false;
      } else {
  
        dropOffTimeError = true;
      }
  
      doo.pickup_time = dropOffTimeStr;
      this.setState({ doo, dropOffTimeError });
    }

  }

  printPickupOrder = (): void => {

    const poNumber: string = this.state.dooNumber;
    const secret: string | undefined = this.props.user.roleId !== 0 ? undefined : this.state.secretKey;

    if (poNumber) {
      handlePrintPickupOrder(poNumber, secret);
    }
  }
  
  handleLockedSealed = (order: PickupOrder): void => {

    const doo: PickupOrder = { ...this.state.doo };

    doo.sealed = order.sealed;
    doo.seal_number = order.seal_number;
    doo.locked = order.locked;

    this.setState({ doo });
    
    if (!doo.sealed  || (doo.sealed && doo.seal_number !== '')) {
      this.saveSecurityDetails(order.locked, order.sealed, order.seal_number);
    }
  }

  handleChangeDropOffDate = (date: MomentType): void => {

    const dropOffDateStr: string = Moment(date).format('YYYYMMDD');

    pickupOrderRemote.driverSetDropOfDate(this.state.dooNumber, this.state.secretKey, { pickup_date: dropOffDateStr }).then((resp: ApiResponse<boolean>) => {

      const success: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (success) {
        
        this.load();
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  render() {

    return (
      <DropOffOrderDriver
        dropOffOrder={ this.state.doo }
        dropOffTimeError={ this.state.dropOffTimeError }
        doCheckIn={ this.doCheckIn }
        selectETA={ this.selectETA }
        printPickupOrder={ this.printPickupOrder }
        dropOffTimeChange={ this.handleDropOffTimeChange }
        setContainerState={ this.handleLockedSealed }
        pickupDateChange={ this.handleChangeDropOffDate }
        pickupDate={ this.state.doo.pickup_date}
      />
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (message: string) => dispatch(receiveSuccess(message))
  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(DropOffOrderDriverContainer);